import { HttpService, Repository, RepositoryBase, Tags, Weaver } from '@skylab-shared/core';
import { InventoryKindModel } from '@skylab-shared/dataModel';
import { pickBy } from '@skylab-shared/utils';
import { InventoryKindBO } from './inventory-kind.bo';


@Repository({
    boType: InventoryKindBO,
    apiController: {
        base: 'inventory/kinds/:name',
        tags: [Tags.Api]
    }
})
export class InventoryKindRepositoryBase extends RepositoryBase<InventoryKindBO, InventoryKindModel> {
    public constructor(
        private readonly weaver: Weaver,
        http: HttpService,
    ) {
        super(http);
    }

    protected createBO(): InventoryKindBO {
        return new InventoryKindBO(this.weaver);
    }

    protected async preparePlainObjectAsync(model: InventoryKindModel): Promise<any> {
        return {
            version: model.version,
            name: model.name,

            adjustment: model.adjustment,
            customTransactionLocation: model.customTransactionLocation,
            defaultCalculationMethod: model.defaultCalculationMethod,
            defaultMarginSchemeId: model.defaultMarginSchemeId,
            defaultPaymentMethodId: model.defaultPaymentMethodId,
            useCustomTransactionLocation: model.useCustomTransactionLocation
        };
    }

    protected async fromPlainObjectAsync(item: any): Promise<InventoryKindModel> {
        return new InventoryKindModel(pickBy<InventoryKindModel>({
            version: item.version,
            name: item.name,

            adjustment: item.adjustment,
            customTransactionLocation: item.customTransactionLocation,
            defaultCalculationMethod: item.defaultCalculationMethod,
            defaultMarginSchemeId: item.defaultMarginSchemeId,
            defaultPaymentMethodId: item.defaultPaymentMethodId,
            useCustomTransactionLocation: item.useCustomTransactionLocation
        }, val => val !== void 0));
    }

    //#endregion
}
